const columns = {
  home: [],
}

export default columns
